module.exports = __webpack_public_path__ + "static/media/1D29430B-3309-4ED9-A617-504A2C25BC63__1_-removebg-preview.9a204b9c.png";